// Libraries
import React from "react";

// Components
import { Button, IconButton } from "@mui/material";
import {BVAButtonContainer} from "./styled";
import Loading from "../Loading/Loading";
import SvgIcon from "../SvgIcon/SvgIcon";

export default function BVAButton({
   children,
   color = "white",
   slimHeight,
   height,
   uppercase,
   kind,
   shape,
   active,
   disabled,
   fluid,
   icon,
   semiBold,
   iconButton,
   iconColor,
   flat,
   iconSize,
   shadow,
   large,
   applyFillOnSVGPath,
   loading,
   onClick = () => ({}),
   type,
   className,
   light,
   id,
 }) {
  return (
    <BVAButtonContainer
      kind={kind}
      semiBold={semiBold}
      shape={shape}
      iconSize={iconSize}
      disabled={disabled}
      iconColor={iconColor}
      light={light}
      id={id}
      shadow={shadow}
      active={active}
      iconButton={iconButton}
      color={color}
      height={height}
      slimHeight={slimHeight}
      flat={flat}
      fluid={fluid}
      large={large}
      uppercase={uppercase}
      applyFillOnSVGPath={applyFillOnSVGPath}
    >
      {iconButton ? (
        <IconButton
          className={className}
          onClick={(e) => onClick(e)}
          id="styled-button"
        >
          <icon.url />
        </IconButton>
      ) : (
        <Button
          onClick={(e) => onClick(e)}
          id="styled-button"
          className={className}
          type={type}
        >
          {loading ? (
            <Loading color="white" />
          ) : icon ? (
            <div className="flex items-center">
              <SvgIcon icon={{ url: icon.url }} />
              <div className="ml-10">{children}</div>
            </div>
          ) : (
            children
          )}
        </Button>
      )}
    </BVAButtonContainer>
  );
}
